import React, { useState } from "react";

function PlayComponent(props) {
  const [state, setState] = useState({
    val: 1
  });
  console.log("PlayComponent runs => " + JSON.stringify(state));

  function click(event) {
    console.log("Clicked! => " + JSON.stringify(state));
    setState(s => ({
      val: s.val + 1
    }));
  }

  return /*#__PURE__*/React.createElement("div", null, "Play class from JSX (state is ", state.val, ")", /*#__PURE__*/React.createElement("button", {
    onClick: click
  }, "Click"), props.children);
}

export const _playComponent = PlayComponent;